<script>
import Datepicker from 'vuejs-datepicker'
import DateUtils from 'vuejs-datepicker/src/utils/DateUtils.js'

export default {
  extends: Datepicker,
  props: {
    bootstrapStyling: {
      type: Boolean,
      default: true
    },
    language: {
      type: String,
      default: 'ru'
    },
    format: {
      type: String | Function,
      default: 'dd.MM.yyyy'
    },
    sendAsString: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setDate (timestamp) {
      const date = new Date(timestamp)
      this.selectedDate = new Date(date)
      this.setPageDate(date)
      this.$emit('selected', this.selectedDate)
      this.$emit('input', DateUtils.formatDate(this.selectedDate, this.format, this.translation))
    },

    setValue (date) {
      if (typeof date === 'string') {
        const [day, month, year] = date.split('.')
        date = new Date(year, month - 1, day)
      }
      if (!date) {
        this.setPageDate()
        this.selectedDate = null
        return
      }
      this.selectedDate = date
      this.setPageDate(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Datepicker.vue?16b66b94